import { maskDate } from './date';
import { maskTime, unmaskTime } from './time';
import { maskIPAddress, unmaskIPAddress } from './ipaddress';
import {
	maskPhone,
	unmaskPhone
} from './phone';

export const maskValue = ( type, value ) => {
	switch ( type ) {
		case 'date':
			return maskDate( value );
		case 'time':
			return maskTime( value );
		case 'ipaddress':
			return maskIPAddress( value );
		case 'phone':
			return maskPhone( value );
		default:
			console.error( 'invalid `type` argument provided to `maskValue` function.' );

			return value;
	}
};

export const unmaskValue = ( type, value ) => {
	switch ( type ) {
		case 'ipaddress':
			return unmaskIPAddress( value );
		case 'phone':
			return unmaskPhone( value );
		case 'time':
			return unmaskTime( value );
		default:
			console.error( 'invalid `type` argument provided to `unmaskValue` function.' );

			return value;
	}
};
